module["exports"] = [
  "Apt. ###",
  "Zimmer ###",
  "# OG"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/address/secondary_address.js
 ** module id = 204
 ** module chunks = 0
 **/